import { gql } from '@apollo/client';

export const GRAPHQL_VARIABLES = {
  filter: {}
};

export const QUERY = `
    query paymentMethodsMany($filter: FilterFindManypaymentMethodsInput){
      paymentMethodsMany(filter:$filter){
          _id
          type
          bank{
              bsb
              account
              name
          }
          card{
              cardNo
              fzToken
          }
          companies
          direction
      }
  }
    `;

export const QUERYV2 = gql`
  query paymentMethodsMany($token: String!, $filter: AutoFilledFilterFindManypaymentMethodsInput) {
    paymentMethodsManyByToken(token: $token, filter: $filter) {
      _id
      card {
        cardNo
        token
        cardType
        holder
        expiry
      }
      type
      bank {
        bsb
        account
        name
        accountType
        type
      }
      counterParty
      name
      companyId
      direction
      provider
      customerId
      expired
      updatedAt
      createdAt
    }
  }
`;
